module.exports = __webpack_public_path__ + "static/media/greateVictory-2.f8220c55.png";